<div
  class="box-drag"
  [class.drag]="dragging"
  (dragover)="$event.preventDefault()"
  (dragenter)="onDragEnter()"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
  [style.background-image]="thumbnail ? 'url(' + thumbnail + ')' : ''"
>
  <label [hidden]="isUploading()">
    <input
      type="file"
      hidden
      accept="image/*,.jpg,.jpeg,.exif,.tiff,.tif,.gif,.bmp,.png,.ppm,.pgm,.pbm,.pnm,.webp,.rgbe,
               .heif,.bpg,.ico,.xisf"
      (change)="onInputFileChange($event)"
    />
  </label>

  <div class="centered drag-here" [hidden]="isUploading() || hasImage()">
    <i inlineSVG="/assets/icons/upload-packshot.svg"></i>
    <p>DRAG HERE</p>
  </div>

  <div class="centered uploading" [hidden]="!isUploading()">
    <img src="/assets/loader3.svg" />
  </div>
</div>
<div class="trash" (click)="setThumbnail(undefined)">
  <i inlineSVG="/assets/icons/pop-trash.svg"></i>
</div>
